import { format } from 'date-fns';

// One day in milliseconds
export const oneDayInMilliseconds = 1000 * 60 * 60 * 24;

export const formattedDate = (date: string) => {
  if (!date) {
    return '';
  }
  return `${format(new Date(date), DATEFORMAT.DATETIMETE)}`;
};

export const localTimezone = () => new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2];

export const DATEFORMAT = {
  DAYDATETIMETZ: "EEE', 'MMM' 'd' at 'p'",
  DAYDATEYEARTIMETZ: "EEE', 'MMM' 'd', 'yyyy' ('p'",
  DAYDATETIMET: "EEEE' 'MMM.' 'do' 'yyyy'",
  DAYDATETIMETE: "EEE,' 'MMM' 'd,' 'yyyy'",
  DATETIMETE: 'MMM d, yyyy',
  MONTHDATETIMETZ: "MMM' 'd,' 'yyyy' at 'p'",
  DAYMONTHZ: "EEE', 'MMM' 'd'",
  MONTHDAYYEAR: 'MM/dd/yyyy'
};

export const getMonthDateTimeTimezone = (date: string | Date) => {
  if (!date) {
    console.error('A date was not provided to getMonthDateTimeTimezone()');
    return '';
  }
  return `${format(new Date(date), DATEFORMAT.MONTHDATETIMETZ)} ${localTimezone()}`;
};

export const getDayMonth = (date: string | Date) => {
  if (!date) {
    console.error('A date was not provided to getDayMonth()');
    return '';
  }
  return `${format(new Date(date), DATEFORMAT.DAYMONTHZ)}`;
};

export const getMonthDayYear = (date: string | Date) => {
  if (!date) {
    return '';
  }

  const parsedDate = new Date(date);

  if (Number.isNaN(parsedDate.getTime())) {
    return '';
  }

  return format(parsedDate, DATEFORMAT.MONTHDAYYEAR);
};

export const getDayDateTimeTimezone = (date: string | Date) => {
  if (!date) {
    return '';
  }
  return `${format(new Date(date), DATEFORMAT.DAYDATETIMETZ)} ${localTimezone()}`;
};

export const getDayDateYearTimeTimezone = (date: string | Date) => {
  if (!date) {
    return '';
  }
  return `${format(new Date(date), DATEFORMAT.DAYDATEYEARTIMETZ)} ${localTimezone()})`;
};

export const getDayDateTimeTime = (date: string | Date) => {
  if (!date) {
    return '';
  }
  return `${format(new Date(date), DATEFORMAT.DAYDATETIMET)}`;
};

export const getUTCDayDateTimeTime = (date: string | Date) => {
  if (!date) {
    return '';
  }

  const dateFormat = new Date(date);
  dateFormat.setMinutes(dateFormat.getMinutes() + dateFormat.getTimezoneOffset());
  return `${format(dateFormat, DATEFORMAT.DAYDATETIMET)}`;
};

export const getDayDateTime = (date: string | Date) => {
  if (!date) {
    return '';
  }
  return `${format(new Date(date), DATEFORMAT.DAYDATETIMETZ)}`;
};

export const formatToUTC = (date: string | Date) => {
  if (!date) return null;
  const utcDate = new Date(date);
  const month = ('0' + (utcDate.getUTCMonth() + 1)).toString().slice(-2);
  const day = ('0' + utcDate.getUTCDate()).toString().slice(-2);
  const year = utcDate.getUTCFullYear();
  const hours = ('0' + utcDate.getUTCHours()).toString().slice(-2);
  const minutes = ('0' + utcDate.getUTCMinutes()).toString().slice(-2);
  const seconds = ('0' + utcDate.getUTCSeconds()).toString().slice(-2);
  return year + '-' + month + '-' + day + 'T' + hours + ':' + minutes + ':' + seconds;
};

/**
 * Formats a timestamp to time string with lowercase am/pm (e.g., "9:18 a.m.")
 * @param timestamp - ISO timestamp string or Date object
 * @returns Formatted time string like "9:18 a.m." or empty string if no timestamp
 */
export const formatTimeWithLowercaseAMPM = (timestamp: string | Date): string => {
  if (!timestamp) {
    return '';
  }
  return new Date(timestamp)
    .toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
    .replace('AM', 'a.m.')
    .replace('PM', 'p.m.');
};
